import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SAVE_KEY_NUMBER_SAGA } from "../sagaTypes";
import { loaderAction, keyNumberAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import {
    currentVisitorsSagaAction,
    getWorkoutsFromCertainSubscriptionSagaAction
} from "../sagaActions";
import { GetWorkoutsThunk } from "../thunks/GetWorkoutsThunk";
import { KEY_NUMBER_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/save_key_number`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSaveKeyNumber(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const pagination = yield select(state => state.pagination);
    const filterDate = yield select(state => state.filterDate);
    const filterTypesOptions = yield select(state => state.filterTypesOptions);
    const filterCoachesOptions = yield select(state => state.filterCoachesOptions);
    const filterOneTimeWorkout = yield select(state => state.filterOneTimeWorkout);
    const filterConstraintsOptions = yield select(state => state.filterConstraintsOptions);
    const filterWorkoutsCountOptions = yield select(state => state.filterWorkoutsCountOptions);
    const filterUser = yield select(state => state.filterUser);
    const current_subscription = yield select(state => state.current_subscription);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('workout_id', args.data.workout_id);
        formData.append('key_number', args.data.key_number);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если передан параметр update: 'workouts' (замена ключа в тренировках)
            if (args.data?.update === 'workouts') {
                // Обновляем тренировки
                yield put(GetWorkoutsThunk({
                    page: pagination.current,
                    from: filterDate.from,
                    to: filterDate.to,
                    subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                    subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                    subscription_constraints: JSON.stringify(filterConstraintsOptions.filter(el => el.active).map(el => el.id)),
                    subscription_workouts_count: JSON.stringify(filterWorkoutsCountOptions.filter(el => el.active).map(el => el.id)),
                    filter_user: filterUser.user.id,
                    oneTime: filterOneTimeWorkout
                }));
            }
            // Если передан параметр update: 'current_user', обновляем тренировки в абонементе карточки пользователя
            else if (args.data?.update === 'current_user_subscription') {
                yield put(getWorkoutsFromCertainSubscriptionSagaAction({
                    subscription_id: current_subscription.subscription_id
                }));
            }
            else {
                // Запрашиваем новый список с текущими посетителями
                yield put(currentVisitorsSagaAction({ establishment: currentEstablishment }));
            }

            yield put(keyNumberAction(KEY_NUMBER_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            // Очищаем данные, если обновляли ключ на странице с тренировками
            if (args.data?.update === 'workouts') {
                yield put(keyNumberAction(KEY_NUMBER_FORM_INITIAL));
            }
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSaveKeyNumber() {
    yield takeLatest(SAVE_KEY_NUMBER_SAGA, workerSaveKeyNumber);
}